import { GenericField } from './generic-field';
import { GenericFieldString } from './generic-field-string';
import { GenericFieldNumber } from './generic-field-number';
import { LocaleService } from '../services/locale.service';

export class rendicontazioneGeneraleType {
	fieldsMap: Map<string, GenericField>;

	constructor(private formatter: LocaleService){
		this.onInit();
	}

	onInit(){
		let fieldLocal: GenericField;
		this.fieldsMap = new Map();

		fieldLocal = new GenericFieldString(this.formatter, "emissione");
		this.fieldsMap.set("emissione", fieldLocal);
		this.setFieldValue("emissione", '');

		fieldLocal = new GenericFieldString(this.formatter, "canale");
		this.fieldsMap.set("canale", fieldLocal);
		this.setFieldValue("canale", '');

		fieldLocal = new GenericFieldNumber(this.formatter, "pagato", "currency");
		this.fieldsMap.set("pagato", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "debito", "currency");
		this.fieldsMap.set("debito", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "notificaSpese", "currency");
		this.fieldsMap.set("notificaSpese", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "oneri", "currency");
		this.fieldsMap.set("oneri", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "aggio", "currency");
		this.fieldsMap.set("aggio", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "altro", "currency");
		this.fieldsMap.set("altro", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "numeroInteri", "number");
		this.fieldsMap.set("numeroInteri", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "numeroRate", "number");
		this.fieldsMap.set("numeroRate", fieldLocal);
    }

	getMap(){
		return this.fieldsMap;
	}

	clearField(key: string){
		this.fieldsMap.get(key).clear();
	}

	getFieldType(key: string){
		return this.fieldsMap.get(key).getType();
	}

    getFieldValue(key: string){
		if(this.fieldsMap.get(key)){
			return this.fieldsMap.get(key).getValue();
		}
	}

	getFieldString(key: string){
		if(this.fieldsMap.get(key)){
			return this.fieldsMap.get(key).getValueString();
		}
	}

	setFieldValue(key: string, value: any){
		//console.log("setFieldValue prima", key, "---", value, "---", this.fieldsMap);
		if(this.fieldsMap.get(key)){
			this.fieldsMap.get(key).setValue(value);
			this.fieldsMap.get(key).toString(this.formatter);
		}
		//console.log("setFieldValue dopo", this.fieldsMap);
	}
};

export class rendicontazioneDettaglioType {
	fieldsMap: Map<string, GenericField>;

	constructor(private formatter: LocaleService){
		this.onInit();
	}

	onInit(){
		let fieldLocal: GenericField;
		this.fieldsMap = new Map();

		fieldLocal = new GenericFieldString(this.formatter, "anagrafica_id");
		this.fieldsMap.set("anagrafica_id", fieldLocal);
		this.setFieldValue("anagrafica_id", '');

		fieldLocal = new GenericFieldString(this.formatter, "nominativo");
		this.fieldsMap.set("nominativo", fieldLocal);
		this.setFieldValue("nominativo", '');

		fieldLocal = new GenericFieldString(this.formatter, "emissione");
		this.fieldsMap.set("emissione", fieldLocal);
		this.setFieldValue("emissione", '');

		fieldLocal = new GenericFieldString(this.formatter, "canale");
		this.fieldsMap.set("canale", fieldLocal);
		this.setFieldValue("canale", '');

		fieldLocal = new GenericFieldString(this.formatter, "anno");
		this.fieldsMap.set("anno", fieldLocal);
		this.setFieldValue("anno", '');

		fieldLocal = new GenericFieldNumber(this.formatter, "pagato", "currency");
		this.fieldsMap.set("pagato", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "debito", "currency");
		this.fieldsMap.set("debito", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "sanzioni", "currency");
		this.fieldsMap.set("sanzioni", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "interessi", "currency");
		this.fieldsMap.set("interessi", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "notificaSpese", "currency");
		this.fieldsMap.set("notificaSpese", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "arrotondamento", "currency");
		this.fieldsMap.set("arrotondamento", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "interessiAgg", "currency");
		this.fieldsMap.set("interessiAgg", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "oneriAgg", "currency");
		this.fieldsMap.set("oneriAgg", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "notificaSpeseAgg", "currency");
		this.fieldsMap.set("notificaSpeseAgg", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "esecutiveSpese", "currency");
		this.fieldsMap.set("esecutiveSpese", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "giudizialiSpese", "currency");
		this.fieldsMap.set("giudizialiSpese", fieldLocal);

		fieldLocal = new GenericFieldString(this.formatter, "accreditoData");
		this.fieldsMap.set("accreditoData", fieldLocal);
		this.setFieldValue("accreditoData", '');

		fieldLocal = new GenericFieldString(this.formatter, "rifRata");
		this.fieldsMap.set("rifRata", fieldLocal);
		this.setFieldValue("rifRata", '');
	}

    getMap(){
		return this.fieldsMap;
	}

	clearField(key: string){
		this.fieldsMap.get(key).clear();
	}

	getFieldType(key: string){
		return this.fieldsMap.get(key).getType();
	}

    getFieldValue(key: string){
		if(this.fieldsMap.get(key)){
			return this.fieldsMap.get(key).getValue();
		}
	}

	getFieldString(key: string){
		if(this.fieldsMap.get(key)){
			return this.fieldsMap.get(key).getValueString();
		}
	}

	setFieldValue(key: string, value: any){
		//console.log("setFieldValue prima", key, "---", value, "---", this.fieldsMap.get(key), "---", this.fieldsMap.get(key).value);
		if(this.fieldsMap.get(key)){
			this.fieldsMap.get(key).setValue(value);
			this.fieldsMap.get(key).toString(this.formatter);
		}
		//console.log("setFieldValue dopo", this.fieldsMap.get(key), "---", this.fieldsMap.get(key).value);
	}
};
